import React, { createContext, useContext, ReactNode } from 'react';
import { useBranding, BrandingConfig } from '../hooks/useBranding';

interface BrandingContextType {
  branding: BrandingConfig;
  loading: boolean;
  error: string | null;
  productName: string;
  logo: string;
  logoIcon: string;
  logoWhite: string;
  logoDark: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
}

const BrandingContext = createContext<BrandingContextType | undefined>(undefined);

interface BrandingProviderProps {
  children: ReactNode;
}

export const BrandingProvider: React.FC<BrandingProviderProps> = ({ children }) => {
  const brandingData = useBranding();

  return (
    <BrandingContext.Provider value={brandingData}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBrandingContext = () => {
  const context = useContext(BrandingContext);
  if (context === undefined) {
    throw new Error('useBrandingContext must be used within a BrandingProvider');
  }
  return context;
}; 